<template>
  <div class="group">
    <div class="label">
      {{ $l.popupQuizPointName }}
    </div>

    <div>
      {{ quiz.get('name') }}
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    quiz: function () {
      return this.$store.state.quiz.quiz
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_style.scss'
</style>
